import { useEffect, useRef } from "react";
import { initAdtrace } from "../../lib/adtrace";

const ADTRACE_ENABLED =
  import.meta.env.VITE_ADTRACE_ENABLE === "true" &&
  !!import.meta.env.VITE_ADTRACE_APP_TOKEN;

export default function AdtraceBootstrap() {
  const did = useRef(false);
  useEffect(() => {
    if (did.current) return;
    if (!ADTRACE_ENABLED) return;
    initAdtrace(); // without userId
    did.current = true;
  }, []);
  return null;
}
